// Core
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';

// Services
import { NewsletterSubscriptionService } from '../../../../services/newsletter/newsletter-service';

// Font Awesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-index-newsletter-section',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
    templateUrl: './index-newsletter-section.html',
    styleUrl: './index-newsletter-section.scss',
})

export class IndexNewsletterSection {

    newsletterForm: FormGroup;
    isSubmitting: boolean = false;
    subscriptionSuccess: boolean = false;
    subscriberFirstName: string  = '';
    failedSubscription: boolean = false;

    // Font Awesome Icons
    faCheck = faCheck;

    constructor(
        private newsletterSubscriptionService: NewsletterSubscriptionService,
        private formBuilder: FormBuilder
    ) {
        this.newsletterForm = this.formBuilder.group({
            firstName: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
            emailAddress: ['', [Validators.email, Validators.required]]
        })
    }

    // Getters & Setters
    get firstName() { return this.newsletterForm.get('firstName'); }
    get lastName() { return this.newsletterForm.get('lastName'); }
    get emailAddress() { return this.newsletterForm.get('emailAddress'); }

    // Handle newsletter subscription form submit
    handleNewsletterSubscriptionForm = async () => {
        this.isSubmitting = true;

        try {
            const payload = this.newsletterForm.value;
            await this.newsletterSubscriptionService.subscribeUserToNewsletter(payload);
            this.subscriberFirstName = this.newsletterForm.get('firstName')?.value;
            this.subscriptionSuccess = true;
            this.isSubmitting = false;
            this.newsletterForm.reset();
        } catch (error) {
            this.failedSubscription = true;
            this.isSubmitting = false;
        }
    }
    
}
